import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { LEAD_WORKSPACE_ACTION_TYPE } from '../actions';

const initialState = {
  applicationContacts: [],
  leadScore: null,
  leadSourceCandidate: null,
  indicativeQuote: null,
  applicationPricingQuote: null,
  applicationPricingQuoteHistory: [],
};

const leadWorkspaceReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case LEAD_WORKSPACE_ACTION_TYPE.GET_LEAD_APPLICATION_CONTACTS:
        draft.applicationContacts = payload;
        break;

      case LEAD_WORKSPACE_ACTION_TYPE.GET_LEAD_SCORE:
      case LEAD_WORKSPACE_ACTION_TYPE.RECOMPUTE_LEAD_SCORE:
        draft.leadScore = payload;
        break;

      case LEAD_WORKSPACE_ACTION_TYPE.CAPTURE_LEAD_SOURCE_CANDIDATE:
        draft.leadSourceCandidate = payload;
        break;

      case LEAD_WORKSPACE_ACTION_TYPE.GET_INDICATIVE_QUOTE:
        draft.indicativeQuote = payload;
        break;

      case LEAD_WORKSPACE_ACTION_TYPE.GET_APPLICATION_PRICING_QUOTE:
        draft.applicationPricingQuote = payload;
        break;

      case LEAD_WORKSPACE_ACTION_TYPE.GET_APPLICATION_PRICING_QUOTE_HISTORY:
        draft.applicationPricingQuoteHistory = payload;
        break;

      case LEAD_WORKSPACE_ACTION_TYPE.RESET_LEAD_WORKSPACE:
      case RESET_STATE:
        return initialState;

      default:
        break;
    }
  });

export default leadWorkspaceReducer;
